/**
 * Axios plugin
 * 
 */

// TOOD: axios is never used using this prototype. Should change all axios calls from vue to use this.$http

import Vue from 'vue'

// Lib imports
import axios from 'axios'

Vue.prototype.$http = axios
